import React from 'react';
import PropTypes from 'prop-types';

class UndeployedChanges extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
  };
  render() {
    return (
      <div
        id="undeployed-changes-alert"
        className="alert alert-info alert-dismissible mb-3"
        style={{ display: this.props.visible ? 'block' : 'none' }}
      >
        設定が変更されています。
        <span style={{ fontWeight: 'bold' }}>
          チャットボットへの反映を行ってください。
        </span>
      </div>
    );
  }
}

export default UndeployedChanges;
